$ var status = input.status || 'attention';

<ebay-notice-base
    ...input
    class=[`page-notice--${status}`, input.class]
    status=status
    role="region"
    prefixClass="page-notice"
/>
